import React from "react"
import gql from "graphql-tag"
import PropTypes from "prop-types"

import authentication from "@irati/auth"

import {Mutation} from "../"
import {comment} from "../../gql/comment"


const mutation = gql`
  mutation UpdateInsightsCommentMutation($params: InsightsCommentInput!) {
    updateInsightsComment(params: $params){
      ${comment}
    }
  }
`

const UpdateCommentMutation = ({children, variables, ...props}) => {
  const defaultParams = {
    tenant: authentication.userTenant().uuid
  }
  const params = {...defaultParams, ...variables}
  return (
    <Mutation mutation={mutation} {...props}>
      {(mutate, apolloState) => {
        return children(
          (args) => {
            mutate({variables: {params}, ...args})
          },
          apolloState
        )
      }}
    </Mutation>
  )
}

UpdateCommentMutation.propTypes = {
  children: PropTypes.func.isRequired,
  variables: PropTypes.object.isRequired
}

UpdateCommentMutation.defaultProps = {
  variables: {}
}

export default UpdateCommentMutation
